import { useState } from 'react';
import preview from './image/preview.png';
import PreviewContent from '../PreviewContent';
import * as EditorTypeAll from '../tinymce.d';

interface Props {
  editorInstance: EditorTypeAll.Editor;
}

const Preview = ({ editorInstance }: Props) => {
  const [previewContent, setPreviewContent] = useState(['', '']);
  const previewAction = () => {
    const html = editorInstance.getContent();
    document.body.click();
    setPreviewContent([html, html]);
  };

  return (
    <>
      <div className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]" onClick={previewAction}>
        <img width="18px" height="18px" src={preview} />
      </div>
      <PreviewContent content={previewContent} onCancel={() => setPreviewContent(['', ''])} />
    </>
  );
};

export default Preview;
